import {
  Box,
  Button,
  ButtonGroup,
  Flex,
  Grid,
  Heading,
  Text,
} from '@chakra-ui/react';

import { ROLE_ENUM } from '@/const/role';
import { TenantSelect } from '@/features/tenant/components/select/tenant-select';
import { useUser } from '@/lib/auth';

type HeaderProps = {
  onPasswordChangeFormModalOpen: () => void;
  onSignOutModalOpen: () => void;
};

export const Header = (props: HeaderProps) => {
  console.info('header.tsx_1');

  const { onPasswordChangeFormModalOpen, onSignOutModalOpen } = props;
  const user = useUser();
  const doLogout = () => {
    console.info('header.tsx_2');
    onSignOutModalOpen();
  };
  return (
    <Flex
      as="header"
      top={0}
      width="100%"
      height="100%"
      shadow="md"
      align="center"
      justify="space-between"
      px={{ base: 2, lg: 4 }}
      bgColor="blue.400"
    >
      <Flex align="center">
        <Grid
          gap={{ base: 1, lg: 2 }}
          templateColumns={{ base: 'repeat(1, 1fr)', xl: 'repeat(2, 1fr)' }}
          ml={{ base: 2, lg: 4 }}
        >
          <Heading color="white" size={{ base: 'md', xl: 'xl' }}>
            Discuss
          </Heading>
          <Heading color="white" size={{ base: 'md', xl: 'xl' }}>
            E-Sign
          </Heading>
        </Grid>
        {user.data?.role_id === ROLE_ENUM.ADMIN ? (
          <TenantSelect />
        ) : (
          <Box ml={4}>
            <Text color="white">{user.data?.tenant_name}</Text>
          </Box>
        )}
      </Flex>
      <Flex align="center">
        <Text color="white" m={2}>
          ユーザー名：{user?.data?.username}
        </Text>
        <ButtonGroup>
          <Button
            size={{ base: 'sm', lg: 'md' }}
            colorScheme="gray"
            onClick={onPasswordChangeFormModalOpen}
          >
            パスワード設定
          </Button>
          <Button
            size={{ base: 'sm', lg: 'md' }}
            colorScheme="gray"
            onClick={doLogout}
          >
            ログアウト
          </Button>
        </ButtonGroup>
      </Flex>
    </Flex>
  );
};
